import { ReactNode } from 'react';
import { useToast } from '@chakra-ui/react';

type ToastStatus = 'info' | 'warning' | 'success' | 'error' | 'loading';

export interface AddToastProps {
  message: ReactNode;
  status: ToastStatus;
  duration?: number;
}

export default function CustomToast() {
  const toast = useToast();

  const addToast = ({ message, status, duration }: AddToastProps): void => {
    toast({
      position: 'top-right',
      title: message,
      status,
      duration: duration !== undefined ? duration : 5000,
      isClosable: true,
    });
  };

  return { addToast };
}
